{
  "policy-info-and-rates": "Información y Tarifas de la Póliza",
  "owners-policy": "Política del Propietario",
  "lenders-policy": "Política del Prestamista",
  "remove-section-13": "Eliminar la Sección 13",
  "endorsements": "Avales",
  "owner": "Dueño",
  "lender": "Prestador",
  "no-endorsement": "No Hay Avales Disponibles",
  "endorsement": "Aval",
  "charge": "Cargo",
  "description": "Descripción",
  "price": "Precio",
  "tooltip": "Los impuestos no se pueden editar para este estado de cierre",
  "actual": "Actual",
  "disclosed": "Divulgación",
  "paid-by": "Pagado Por",
  "buyer": "Comprador",
  "seller": "Vendedor",
  "split": "Separar",
  "disclosed-title-payee": "Beneficiario del Título Divulgado",
  "payment-breakdown": "Desglose de Pagos",
  "policy": "Política",
  "fees-taxes": "Tasas / Impuestos",
  "remove": "Eliminar",
  "total": "Total",
  "alert-p-1": "Para ver los valores de las pólizas, asegúrese de que el precio de compra y los montos de los préstamos estén ingresados ​​en la pantalla de propiedades.",
  "payee-info": "Payee Information",
  "not-defined-yet": "No Definido todavia",
  "credits": "Creditos",
  "removeEndorsement": "Remover el endoso",
  "removeConfirmation": "¿Estás seguro de que quieres eliminar el endoso?",
  "removeButton": "Remover",
  "endorsementRemoved": "Se removio el endoso",
  "endorsementAdded": "Se agrego el endoso",
  "endorsementExisting": "Endoso existente",
  "policyTypeLabel": "Tipo de Póliza",
  "rateTypeLabel": "Tipo de Tarifa",
  "rateTypeStatCodeLabel": "Código Estadístico de Tipo de Tarifa",
  "disclosureSectionLabel": "Sección de Divulgación",
  "association-deleted": "Asociación Eliminada",
  "deleting": "Eliminando",
  "totalCoverage": "Cobertura total"
}
